<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">{{getTitle()}}</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>
<div class="w-100 d-flex justify-content-center align-items-center contenedor">
  <div *ngIf="tieneServicios && step === 1" class=" d-flex flex-column justify-content-center" style="width: 80%;">
    <!-- <span class="fs-18px mt-2"><b></b></span> -->
    <div *ngFor="let llanta of carrito">
      <div *ngIf="llanta.serviciosSeleccionados.length > 0">
        <span class="fs-16px mt-4 w-100 text-start"><b>{{llanta.label}}</b></span>
        <div class="d-flex flex-column align-items-center w-100">
          <div *ngFor="let serv of llanta.serviciosSeleccionados" class="servicios-item">
              <img [src]="serv.img"/>
              <span style="font-weight: bold; font-size: 14px">{{serv.label}}</span>
              <input class="big-checkbox" type="checkbox" checked disabled>
          </div>
        </div>  
      </div>
      <div *ngIf="llanta.serviciosSeleccionados.length > 0" class="divisor-seccion"></div>
    </div>

    <div class="w-100 d-flex flex-row justify-content-between align-items-center mt-2">
      <button class="btn btn-primary" (click)="closeDialog()">Cerrar</button>
      <button class="btn btn-success" (click)="nextStep()">Redimir Servicios</button>
    </div>
    <br><br>
  </div>
  <div *ngIf="step === 2" class="col-12">
    <span class="fs-14px">Toma una fotografía clara de <b>Placas</b></span>
    <app-webcam (imageCaptured)="onImage($event)" [opcion]="1" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>
    <div class="mt-2 mb-2 d-flex justify-content-end align-items-center w-100">
      <button class="btn btn-primary" [disabled]="getDisabled()" (click)="nextStep()">Guardar</button>
    </div>
  </div>

  <!-- <div *ngIf="step === 3" class="col-12">
    <span class="fs-14px">Toma una fotografía clara de <b>Tacómetro</b></span>
    <app-webcam (imageCaptured)="onImage($event)" [opcion]="2" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>
    <span class="fs-14px font-weight-bold">Kilometraje</span>
    <input class="form-control" placeholder="Ingresa Kilometraje del auto" [(ngModel)]="kilometraje"  formatearMiles type="text" inputmode="numeric" (keydown)="limpiarCaracteresNoNumericos($event)" (keypress)="soloNumeros($event)"/>
    <div class="mt-2 mb-2 d-flex justify-content-end align-items-center w-100">
      <button class="btn btn-primary" [disabled]="getDisabled()" (click)="nextStep()">Guardar</button>
    </div>

  </div> -->

  <div *ngIf="step === 3" class="col-12">
    <span class="fs-14px">Toma una fotografía clara de <b>Identificación Oficial</b></span>
    <app-webcam (imageCaptured)="onImage($event)" [opcion]="3" (capturaReiniciada)="desactivarContinuar($event)"></app-webcam>
    <div class="mt-2 mb-2 d-flex justify-content-end align-items-center w-100">
      <button class="btn btn-primary" [disabled]="getDisabled()" (click)="nextStep()">Guardar</button>
    </div>
  </div>
  <div *ngIf="tieneServicios && step === 4">
    <legend class="fs-14px">Realiza tu firma para confirmar el servicio</legend>
    <app-signature-pad (signatureSaved)="onSignature($event)" (cleanSignature)="limpiarFirma()"></app-signature-pad>
    <div class="mt-2 mb-2 d-flex justify-content-end align-items-center w-100">
      <button class="btn btn-primary" [disabled]="getDisabled()" (click)="redimirServicios()">Redimir Servicios</button>
    </div>
  </div>
  <div *ngIf="!tieneServicios" class=" d-flex flex-column justify-content-center align-items-center" style="width: 100%; height: 240px;">
    
    <i class="fa-solid fa-triangle-exclamation" style="color: #f3d41e; font-size: 36px;"></i>
    <p style="color: black; font-size: 16px; max-width: 400px; text-align: center;"><b>No se han seleccionado servicios.</b></p>

    <div class="w-100 d-flex flex-row justify-content-around align-items-center mt-2">
      <button class="btn btn-primary" (click)="closeDialog()">Cerrar</button>
    </div>
  </div>
</div>
